import React, { useEffect, useState } from 'react';
import * as S from './estilos';
import { Oval } from 'react-loader-spinner';
function Load(props: any) {
  return (
    // eslint-disable-next-line react/prop-types
    props.status && (
      <>
        <S.ForaSpiner style={{zIndex: 2000}}>
          <Oval
            // type='Puff'
            color='#fc551e'
            height={100}
            width={100}           
            secondaryColor='#fff'
            // timeout={3000} //3 secs
          />
        </S.ForaSpiner>
      </>
    )
  );
}

export default Load;
